module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter1"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("1.")]), _vm._v(" The City of Brass")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter2"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("2.")]), _vm._v(" South Wales Strife (1): Newport")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("3.")]), _vm._v(" South Wales Strife (2): Tonypandy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("4.")]), _vm._v(" Cutting off ‘this stream of madness’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("5.")]), _vm._v(" Crime, Punishment, and the ‘Prisoners’ Friend’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("6.")]), _vm._v(" Mrs Pankhurst’s Army of Amazons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("7.")]), _vm._v(" A Whiff of Cordite")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("8.")]), _vm._v(" ‘a dim spectre of revolution’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpada"
  }, [_vm._v("9.")]), _vm._v(" As Dead as Queen Anne")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocpad"
  }, [_vm._v("10.")]), _vm._v(" ‘Home Secretaries never do have an easy time’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0